import React from "react";


import Carousel from "../components/Carousel";
import Navbar from "../components/Navbar";


import AboutUSPage from "../section/AboutUSPage";
import IdeaSectionAbout from "../section/IdeaSectionAbout";
import Feedbacks from "../components/Feedbacks";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import PartnersLogos from "../components/PartnersLogos";
import { Helmet } from 'react-helmet';
import BlogPosts from "../components/BlogPosts";
import AboutBlogPage from "../section/AboutBlogPage";

function AboutUs() {
  return (
    <div className="relative z-0 bg-[#060816]">
       <Helmet>
        <title>Blog - The Designsinc.</title>
      </Helmet>
      <div>
        <Navbar />
        <div>
          {/** About Section */}
          <div className="mt-10">
          <AboutBlogPage  />
          </div>
          {/**Slider logos company */}
          <PartnersLogos />

          {/**idea section and btns */}
          <BlogPosts />

         
          {/** contact section */}

          
          <div className='relative z-0'>
        <Contact />
       
      </div>
        </div>
      </div>

     

      <Footer />
    </div>
  );
}

export default AboutUs;
